var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-menu"},[_c('appLogo'),(_vm.currentAccountSets||_vm.User.role=='Admin')?_c('Menu',{ref:"menu",attrs:{"accordion":"","datas":_vm.menus,"inlineCollapsed":_vm.sliderCollapsed,"className":`h-menu-${_vm.theme}`},on:{"select":_vm.trigger}}):_vm._e(),_c('div',{staticClass:"app-menu-mask",on:{"click":_vm.hideMenu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }